import React from 'react';
import { useSelector } from 'react-redux';

import { matchAccessControl } from 'modules/users/selectors/currentUser';

import { ROLE } from './AccessControlType';

/**
 * @typedef {{
 *  allowedAuths: import('modules/global/typing/enums/extensions.enum').ExtensionEnum[] | import('modules/users/types/users.enum').UserRoleEnum[],
 *  authsType?: 'EXTENSION' | 'ROLE',
 * }} UseAccessControlProps
 */

/**
 * @typedef {{
 *  children?: React.ReactNode,
 *  renderNoAccess?: React.ReactNode
 * } & UseAccessControlProps} AccessControlProps
 */
/** @type {React.FC<AccessControlProps>} */
const AccessControl = ({ children, renderNoAccess = null, ...otherProps }) => {
  const accessControlProps = { authsType: ROLE, allowedAuths: [], ...otherProps };
  const isDisplayed = useSelector(state => matchAccessControl(state, accessControlProps));
  const showNoAccess = !isDisplayed && !!renderNoAccess;

  return (
    <React.Fragment>
      {isDisplayed && children}
      {showNoAccess && renderNoAccess}
    </React.Fragment>
  );
};

export default AccessControl;
